import { Pill } from '@mantine/core'
import classes from './Pill.module.css'

export const PillThemeKobo = Pill.extend({
  classNames: classes,
})
